import { useState, useEffect } from 'react';
// import { useDispatch } from "react-redux";
// styles
import styled from "@emotion/styled";
import { css } from '@emotion/react'
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';

const RenderRadioButton = ({ id, name, labels, vals, helperText, labelPlacement = "end", direction = 'row', tooltip, onClick = () => {}, input, meta: { touched, error }, ...custom }) => {

  const handleChange = (value) => {
    input.onChange(value);
  }

  return (
    <FormControl>
      <RadioGroup
        name={name}
        onChange={(e) => handleChange(e.target.value)}
        row={direction === 'row'}
        css={styledRadioGroup}
      >
      {
        vals.map((val, index) => (
          <FlexDiv key={index}>
            <FormControlLabel
                value={val}
                control={
                  <Radio
                      color="primary"
                      checked={val == input.value}
                      onClick={() => onClick()}
                      className="radioBtn"
                  />
                }
                label={labels[index]}
                labelPlacement={labelPlacement}
                {...custom}
            />
            {
              tooltip &&
              tooltip.map((value,i) => {
                const TagName = value.component
                if (val === value.code) return <TagName key={i}/>
                return false
              })
            }
          </FlexDiv>
        ))
      }
      </RadioGroup>
      {
        helperText && (
          <FormHelperText>{helperText}</FormHelperText>
        )
      }
      {
        touched && error && (
          <span className="error">{error}</span>
        )
      }
    </FormControl>
  );
}

export default RenderRadioButton;

const styledRadioGroup = css`
  margin-left: 1rem;
`;

const FlexDiv = styled.div({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row'
})
